import type { Hub, Severity } from '@sentry/types';

import { getMetaInfoFromObject } from '../helpers';

import { SENTRY_TAG_PACKAGE_NAME, SENTRY_TAG_TEAM_NAME, SentrySeverity } from './config';
import type { TTeamNames } from './config';
import { isSentryAvailable, normalizeError } from './helpers';

declare global {
    // TODO хорошо бы в будущем исправить - eslint хелпер хочет чтобы была запись IWindow
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Window {
        Sentry: Hub;
    }
}

export type TConfig = {
    /**
     * Уровень ошибки
     * @remarks Используйте ключ объекта `SentrySeverity`
     */
    level?: Severity;
    /** Название пакета */
    packageName: string;
    /** Название команды */
    teamName: TTeamNames;
};

/**
 * TODO нужно в будущем заменить в АССР и АКИТ setExtra на setContext т.к. первый уже deprecated
 */
export function sentryCaptureException(
    exception: unknown,
    config: TConfig,
    context?: { data: Record<string, unknown>; name: string }
) {
    if (!isSentryAvailable()) {
        return;
    }

    window.Sentry.withScope(scope => {
        const normalizedError = normalizeError(exception);
        const teamName = String(config.teamName).toLowerCase();
        const packageName = String(config.packageName).toLowerCase();
        const level = config.level || SentrySeverity.Error;

        scope.setTag(SENTRY_TAG_TEAM_NAME, teamName);
        scope.setTag(SENTRY_TAG_PACKAGE_NAME, packageName);
        scope.setLevel(level);

        // Добавляем контекст при этом маскируя все данные,
        // чтобы в сентри случайно не улетели конфиденциальные данные пользователей
        if (context) scope.setContext(context.name, getMetaInfoFromObject(context.data));

        // example - [invest-smev]: Request failed with status code 403
        normalizedError.message = `[${teamName}-${packageName}]: ${normalizedError.message}`;
        window.Sentry.captureException(normalizedError);
    });
}
